module.exports = __webpack_public_path__ + "img/totalmeetings300.1ff689af.png";